import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../../context/SiteContentContext';

const StoryTeaser = () => {
  const { siteContent } = useSiteContent();
  const storyTeaser = siteContent?.storyTeaser || {};

  if (storyTeaser.visible === false) return null;

  return (
    <section className="py-14 sm:py-16 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="rounded-xl sm:rounded-2xl overflow-hidden">
              <img
                src={siteContent?.images?.storyImage || 'https://images.unsplash.com/photo-1631947430066-48c30d57b943?q=80&w=2000&auto=format&fit=crop'}
                alt="Our Story"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="text-center lg:text-left"
          >
            <span className="text-xs sm:text-sm font-medium text-slate-400 uppercase tracking-wider mb-3 sm:mb-4 block">
              {storyTeaser.label || 'Our Story'}
            </span>
            <p className="text-base sm:text-lg md:text-xl text-slate-600 leading-relaxed mb-5 sm:mb-6">
              {storyTeaser.text || 'Helping learners worldwide build English skills since 2007.'}
            </p>
            <Link
              to="/about"
              className="inline-flex items-center text-sm font-medium text-slate-900 hover:text-slate-600 transition-colors py-2"
            >
              {storyTeaser.linkText || 'Read our story'}
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StoryTeaser;
